export enum GroupingTypes {
  Standalone = 'Standalone',
  Integrated = 'Integrated',
}
